import http from './../utils/axios'
import Vue from 'vue'
import router from './../router/index'
import { cat } from 'shelljs'
export function DownloadFile(filePath) {
    if (filePath === undefined || filePath == null || filePath.trim() === '') {
        return
    }
    let path = filePath.split('/')
    http.post(process.env.COREAPI_HOST +  '/Attachment/DownloadFile', {
        filePath: filePath
    }, {
        responseType: 'arraybuffer'
    }).then(response => {
        let fileDownload = require('js-file-download')
        let fileName = path[path.length - 1]
        fileDownload(response.data, fileName)
    })
}
export function DownloadFileByID(id, name) {
    http.post(process.env.COREAPI_HOST +  '/Attachment/DownloadFileByID', {
        AttachmentID: id
    }, {
        responseType: 'arraybuffer'
    }).then(response => {
        let fileDownload = require('js-file-download')
        fileDownload(response.data, name)
    })
}

export function DownloadAppointName(filePath, fileName) {
    if (filePath === undefined || filePath == null || filePath.trim() === '') {
        return
    }
    http.post(process.env.COREAPI_HOST +  '/Attachment/DownloadFile', {
        filePath: filePath
    }, {
        responseType: 'arraybuffer'
    }).then(response => {
        let fileDownload = require('js-file-download')
        fileDownload(response.data, fileName)
    })
}
export function InventoryDay(InventoryDay) {
    return parseInt(InventoryDay) === 999999 ? '∞' : InventoryDay
}
// 删除 -- 表格分页
export function handlePage(page, per, totalCount) {
    let pageNumber = page
    if (page > 1) {
        pageNumber = totalCount % per === 1 ? page - 1 : page
    }
    return pageNumber
}
// 附件上传返回错误不走统一拦截处理
export function handleUploadErrorPublic(file, uploadError) {
    let fileAll = ''
    let fileToString = file
    if (typeof file === 'object') {
        fileToString = JSON.stringify(file)
    }
    if (fileToString.indexOf('"Message":') !== -1) {
        if (typeof file === 'object') {
            fileAll = file.Message
        } else {
            fileAll = JSON.parse(file).Message
        }
    } else {
        fileAll = uploadError
        localStorage.clear()
        router.push({ name: 'loginJump', params: { code: 'system.userIdentityExpired' } })
    }
    Vue.prototype.$Message.error({
        content: fileAll,
        duration: 5
    })
}
export function deepCopy(obj) {
    if (obj == null || typeof obj !== 'object') return obj;

    // Handle Date
    if (obj instanceof Date) {
        var copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if (obj instanceof Array) {
        let copy = [];
        for (var i = 0, len = obj.length; i < len; ++i) {
            copy[i] = deepCopy(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if (obj instanceof Object) {
        let copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) copy[attr] = deepCopy(obj[attr]);
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
}

export function NumFormat(num) {
    try {
        var res = num.toString().replace(/\d+/, function (n) {
            // 先提取整数部分
            return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
                return $1 + ",";
            });
        });
        return res;
    } catch (error) {
        return num;
    }
}

/**
 * 通用导出文件下载.
 * @param {Object} response - axios 响应对象 (需 responseType: 'arraybuffer')
 * @param {string} [fileName] - 调用方指定的文件名(可不带后缀).
 *   - 若未传则走响应头 filename / Content-Disposition / content-type 推断.
 *   - 若传入:
 *       已有后缀 + content-type 给出明确类型(csv/pdf/png/zip): 不匹配则替换为正确后缀.
 *       已有后缀 + content-type 为 octet-stream 等通用类型: 信任调用方后缀, 不替换.
 *       无后缀 + content-type 给出明确类型: 追加正确后缀.
 *       无后缀 + octet-stream: 默认追加 .xlsx (本系统后端用此类型返回 Excel).
 */
export function downloadExportFile(response, fileName) {
    var ct = response.headers['content-type'] || ''
    var ext = ''
    // 只对明确的 content-type 映射扩展名; octet-stream 是通用二进制流,
    // 后端既用它返回 xlsx (DataSyncControllerBase) 也用它返回 zip, 不在此映射.
    if (ct.indexOf('application/zip') >= 0) {
        ext = '.zip'
    } else if (ct.indexOf('text/csv') >= 0) {
        ext = '.csv'
    } else if (ct.indexOf('application/pdf') >= 0) {
        ext = '.pdf'
    } else if (ct.indexOf('application/png') >= 0) {
        ext = '.png'
    }

    if (fileName) {
        var lastDot = fileName.lastIndexOf('.')
        var lastSep = Math.max(fileName.lastIndexOf('/'), fileName.lastIndexOf('\\'))
        var hasExt = lastDot > lastSep
        if (hasExt) {
            // 调用方已指定后缀
            if (ext) {
                // content-type 给出明确类型: 不匹配则替换
                var existingExt = fileName.slice(lastDot).toLowerCase()
                if (existingExt !== ext.toLowerCase()) {
                    fileName = fileName.slice(0, lastDot) + ext
                }
            }
            // content-type 为 octet-stream 等通用类型时, 信任调用方后缀, 不替换
        } else {
            // 调用方未指定后缀
            if (ext) {
                fileName = fileName + ext
            } else if (ct.indexOf('application/octet-stream') >= 0) {
                // octet-stream 在本系统默认是 xlsx (后端 DataSyncControllerBase 用此类型返回 Excel)
                fileName = fileName + '.xlsx'
            }
        }
    } else {
        // 调用方未指定文件名, 走响应头推断
        fileName = ''
        if (response.headers['filename']) {
            fileName = decodeURIComponent(response.headers['filename'])
        }
        if (!fileName) {
            var cd = response.headers['content-disposition'] || ''
            var match = cd.match(/filename\*=UTF-8''(.+?)(?:;|$)/)
            if (match) {
                fileName = decodeURIComponent(match[1])
            } else {
                match = cd.match(/filename="?([^";]+)"?/)
                if (match) {
                    fileName = match[1]
                }
            }
        }
        if (!fileName) {
            fileName = ext ? ('ExportData' + ext) : 'ExportData'
        }
    }
    require('js-file-download')(response.data, fileName)
}

export default {
    DownloadFile,
    DownloadFileByID,
    DownloadAppointName,
    InventoryDay,
    handlePage,
    handleUploadErrorPublic,
    deepCopy,
    NumFormat,
    downloadExportFile
}



// WEBPACK FOOTER //
// ./src/assets/publicJS.js